import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/entities/new')({});
